


















import { IDecimalRoundBehavior, RoundKinds } from "../../../../domain/format/objects";
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin, NumberInput } from "../../../../../base/components/system";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    NumberInput,
    OptionDropDownSelector
  }
})
export default class DecimalRoundBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IDecimalRoundBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDecimalRoundBehavior) => T, defaultValue: T) => T;

  get isDecimalRoundEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isDecimalRoundEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get decimalPlace(): number {
    return this.readPropertyOrDefault(s => s.numberOfDecimalPlaces, 0);
  }

  set decimalPlace(value: number) {
    this.writePropertyWhenValid(s => s.numberOfDecimalPlaces = value);
  }

  get decimalKind(): RoundKinds {
    return this.readPropertyOrDefault(s => s.kind, RoundKinds.Round);
  }

  set decimalKind(value: RoundKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  isValid(value: number): boolean {
    return (0 <= value);
  }

  kindOptions: StandardOption<number>[] = [
    new StandardOption<number>("四捨五入", RoundKinds.Round),
    new StandardOption<number>("切り上げ", RoundKinds.Ceil),
    new StandardOption<number>("切り捨て", RoundKinds.Floor),
  ];
}
